module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"用户名":"User Name","密码":"Password","登录":"Login","语言":"Language","请输入用户名":"Please input username","请输入密码":"Please input password"}}')
  delete Component.options._Ctor
}
